import React, { useState } from "react";
import {
  FaUniversity,
  FaCalendarAlt,
  FaGraduationCap,
  FaCheckCircle,
  FaIndustry,
  FaClipboardList,
  FaGlobe,
  FaChartLine,
  FaFileAlt,
  FaArrowRight,
  FaRegClock,
  FaAward,
  FaMoneyBillWave,
  FaPercent,
  FaExclamationTriangle,
} from "react-icons/fa";

const DPharmaSection = () => {
  const [activeTab, setActiveTab] = useState("career");

  const careerCategories = [
    {
      title: "Pharmaceutical Industry",
      icon: <FaIndustry className="text-xl" />,
      careers: ["Production & Manufacturing", "Research & Development", "Quality Control/Quality Assurance", "Marketing"],
    },
    {
      title: "Clinical & Regulatory",
      icon: <FaClipboardList className="text-xl" />,
      careers: ["Hospital Pharmacy", "Forensic Pharmacy", "Clinical trials", "Regulatory affairs/IPR"],
    },
    {
      title: "Academics & Global",
      icon: <FaGlobe className="text-xl" />,
      careers: ["Community Pharmacy", "Academic & Research", "Opportunity to go Abroad", "Pharmacovigilance", "Medical writing"],
    },
  ];
  const feeStructure = {
    total: "₹1,20,000",
    perYear: "₹60,000",
    installments: [
      {
        year: "1st Year",
        items: [
          { particular: "Admission Fee", time: "At Admission", amount: "₹15,000" },
          { particular: "1st Installment", time: "At 1st Sessional Exam", amount: "₹30,000" },
          { particular: "2nd Installment", time: "At 2nd Sessional Exam", amount: "₹15,000" },
        ],
      },
      {
        year: "2nd Year",
        items: [
          { particular: "Admission Fee", time: "At Admission", amount: "₹15,000" },
          { particular: "1st Installment", time: "At 1st Sessional Exam", amount: "₹30,000" },
          { particular: "2nd Installment", time: "At 2nd Sessional Exam", amount: "₹15,000" },
        ],
      },
    ],
    notes: [
      "Excluding charges for Books, Uniform, Registration & Examination fees.",
      "Exam fee to be paid separately by students.",
      "Industrial Visit charges applicable.",
      "10% discount if total session fee paid in one go.",
      "10% discount for students with 85% or above in 12th.",
      "Late fee: ₹100/day for delayed payments.",
    ],
  };

  return (
    <section className="py-20 px-4 relative overflow-hidden bg-gradient-to-br from-slate-50 via-white to-blue-50">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-green-300/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-10 right-10 w-80 h-80 bg-blue-300/20 rounded-full blur-3xl animate-pulse delay-1000" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-green-100/10 via-transparent to-transparent" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-1.5 rounded-full text-sm font-medium mb-4">
            <FaAward className="text-sm" />
            <span>PCI Approved | AICTE Recognized</span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 bg-gradient-to-r from-green-600 via-blue-600 to-green-600 bg-clip-text text-transparent animate-gradient">
            Diploma in Pharmacy
          </h1>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            A 2‑year program designed to shape future pharmacy professionals with hands‑on training and industry exposure.
          </p>
        </div>
        <div className="group transition-all duration-700 transform translate-y-8 hover:-translate-y-1">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100 hover:shadow-3xl transition-all duration-500">
            <div className="p-8 md:p-10">
              <div className="flex flex-wrap justify-between items-start mb-8">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-800">DIPLOMA IN PHARMACY</h2>
                  <p className="text-gray-500 mt-1 flex items-center gap-2">
                    <FaGraduationCap className="text-green-500" />
                    <span>Seats: 60 per year</span>
                  </p>
                </div>
                <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white px-5 py-2 rounded-full text-sm font-semibold shadow-md">
                  College Code: 883
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4 mb-8">
                <div className="bg-gradient-to-br from-green-50 to-white p-4 rounded-xl text-center shadow-sm border border-green-100">
                  <div className="text-2xl font-bold text-green-600">2 Years</div>
                  <div className="text-xs text-gray-500">Duration</div>
                </div>
                <div className="bg-gradient-to-br from-blue-50 to-white p-4 rounded-xl text-center shadow-sm border border-blue-100">
                  <div className="text-2xl font-bold text-blue-600">60</div>
                  <div className="text-xs text-gray-500">Intake Capacity</div>
                </div>
              </div>

              <div className="mb-8 space-y-3">
                <div className="flex items-center gap-3 text-gray-700">
                  <FaUniversity className="text-green-500 text-lg" />
                  <span className="text-sm">Affiliating Board: <strong>Board of Technical Education, Uttar Pradesh</strong></span>
                </div>
                <div className="flex items-center gap-3 text-gray-700">
                  <FaCalendarAlt className="text-blue-500 text-lg" />
                  <span className="text-sm">Course Structure: <strong>Yearly Examination System</strong> (Theory + Practicals + Individual Training)</span>
                </div>
              </div>

              <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-5 rounded-xl mb-8 border-l-4 border-green-500">
                <h4 className="font-bold text-gray-800 flex items-center gap-2 mb-2">
                  <FaGraduationCap className="text-green-600" /> Eligibility Criteria
                </h4>
                <p className="text-gray-700 text-sm">10+2 with 50% aggregate in Physics, Chemistry, Biology/Mathematics (PCB/PCM).</p>
                <p className="text-gray-500 text-xs mt-2">* As per PCI norms.</p>
              </div>

              <div className="flex flex-wrap gap-4">
                <button className="px-6 py-3 bg-gradient-to-r from-green-600 to-emerald-700 text-white rounded-xl font-semibold text-sm hover:shadow-lg transform hover:-translate-y-0.5 transition-all flex items-center gap-2 group/btn">
                  Apply Now
                  <FaArrowRight className="group-hover/btn:translate-x-1 transition-transform" />
                </button>
                <button className="px-6 py-3 border-2 border-gray-300 bg-white text-gray-700 rounded-xl font-semibold text-sm hover:bg-gray-50 hover:border-gray-400 transition-all flex items-center gap-2">
                  <FaFileAlt className="text-green-500" />
                  Download Brochure
                </button>
              </div>
            </div>

            {/* Right Column - Tabs */}
            <div className="bg-gradient-to-br from-slate-50 to-white p-6 md:p-8 border-t lg:border-t-0 lg:border-l border-gray-100">
              <div className="flex gap-4 mb-6 border-b border-gray-200">
                <button
                  onClick={() => setActiveTab("career")}
                  className={`pb-2 px-2 font-semibold text-sm transition-colors ${
                    activeTab === "career"
                      ? "text-green-600 border-b-2 border-green-600"
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                >
                  Career Opportunities
                </button>
                <button
                  onClick={() => setActiveTab("fee")}
                  className={`pb-2 px-2 font-semibold text-sm transition-colors ${
                    activeTab === "fee"
                      ? "text-green-600 border-b-2 border-green-600"
                      : "text-gray-500 hover:text-gray-700"
                  }`}
                >
                  Fee Structure
                </button>
              </div>

              {activeTab === "career" && (
                <div>
                  <div className="flex items-center gap-2 mb-4">
                    <FaChartLine className="text-blue-600 text-xl" />
                    <h3 className="text-xl font-bold text-gray-800">Career in Pharmacy</h3>
                  </div>
                  <p className="text-gray-600 text-sm mb-6">
                    A diploma in pharmacy opens doors to diverse opportunities across industries. Here's where our graduates thrive:
                  </p>
                  <div className="space-y-5">
                    {careerCategories.map((cat, idx) => (
                      <div key={idx}>
                        <div className="flex items-center gap-2 mb-2">
                          <div className="p-1 bg-white rounded-full shadow-sm text-green-500">
                            {cat.icon}
                          </div>
                          <h4 className="font-semibold text-gray-800">{cat.title}</h4>
                        </div>
                        <div className="grid grid-cols-2 gap-1 ml-6">
                          {cat.careers.map((career, i) => (
                            <div key={i} className="flex items-start gap-2 text-gray-600 text-xs">
                              <FaCheckCircle className="text-green-500 text-xs mt-0.5 flex-shrink-0" />
                              <span>{career}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-6 p-3 bg-blue-50/50 rounded-xl border border-blue-100">
                    <p className="text-xs text-gray-500 flex items-center gap-1">
                      <FaRegClock className="text-blue-400" />
                      * Excellent scope for higher studies (B.Pharm, MBA, etc.) and overseas opportunities.
                    </p>
                  </div>
                </div>
              )}

              {activeTab === "fee" && (
                <div>
                  <div className="flex items-center gap-2 mb-4">
                    <FaMoneyBillWave className="text-green-600 text-xl" />
                    <h3 className="text-xl font-bold text-gray-800">Fee Structure 2025-26</h3>
                  </div>
                  <div className="bg-white rounded-xl p-4 mb-4 shadow-sm border border-gray-100">
                    <div className="flex justify-between items-center mb-3">
                      <span className="text-sm font-semibold text-gray-700">Total Contract Fee:</span>
                      <span className="text-xl font-bold text-green-600">{feeStructure.total}</span>
                    </div>
                    <div className="text-sm text-gray-500 mb-4">(₹60,000 per year)</div>

                    {feeStructure.installments.map((yearData, idx) => (
                      <div key={idx} className="mb-5">
                        <h4 className="font-semibold text-gray-800 mb-2 text-sm">{yearData.year}</h4>
                        <div className="overflow-x-auto">
                          <table className="min-w-full text-xs">
                            <thead className="bg-gray-50">
                              <tr>
                                <th className="px-2 py-1 text-left">Particulars</th>
                                <th className="px-2 py-1 text-left">Due Time</th>
                                <th className="px-2 py-1 text-right">Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {yearData.items.map((item, i) => (
                                <tr key={i} className="border-t border-gray-100">
                                  <td className="px-2 py-1">{item.particular}</td>
                                  <td className="px-2 py-1">{item.time}</td>
                                  <td className="px-2 py-1 text-right font-medium">{item.amount}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ))}

                    <div className="mt-4 pt-3 border-t border-gray-200">
                      <div className="flex items-center gap-1 text-xs text-gray-500 mb-2">
                        <FaExclamationTriangle className="text-yellow-500" />
                        <span className="font-semibold">Important Notes:</span>
                      </div>
                      <ul className="text-xs text-gray-500 space-y-1 list-disc pl-4">
                        {feeStructure.notes.map((note, i) => (
                          <li key={i}>{note}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="flex justify-between items-center text-xs text-gray-500 mt-2 p-2 bg-green-50 rounded-lg">
                    <span>Discounts available</span>
                    <FaPercent className="text-green-600" />
                    <span>Up to 10%</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DPharmaSection;